import { Box, makeStyles, Typography } from "@material-ui/core";
import { FC, useEffect, useState } from "react";
import CustomCard from "../../../components/CustomCard";

const useStyles = makeStyles({
  attachmentInputContainer: {
    position: "relative",
    border: "4px dashed #d6d6d6",
    padding: "30px 20px 20px",
    "& input": {
      width: "100%",
      position: "absolute",
      top: "30px",
      left: 0,
      opacity: 0,
      cursor: "pointer",
    },
  },
  attachmentInputText: {
    textAlign: "center",
    marginBottom: 25,
  },
});

const ProfileLogo: FC<any> = ({ logo, setUploadLogo, title = "Logo" }) => {
  const classes = useStyles();
  const [selectedLogo, setSelectedLogo] = useState<any>(null);
  const [preview, setPreview] = useState<any>(null);

  const uploadLogo = async (e: any) => {
    const logo = e.target.files[0];
    setSelectedLogo(logo);
    setUploadLogo(logo);
  };

  useEffect(() => {
    let fileReader: any = null,
      isCancel = false;
    if (selectedLogo) {
      fileReader = new FileReader();
      fileReader.onload = (e: any) => {
        const { result } = e.target;
        if (result && !isCancel) {
          setPreview(result);
        }
      };
      fileReader.readAsDataURL(selectedLogo);
    }
    return () => {
      isCancel = true;
      if (fileReader && fileReader.readyState === 1) {
        fileReader.abort();
      }
    };
  }, [selectedLogo]);

  return (
    <CustomCard width="50%" title={title}>
      <Box className={classes.attachmentInputContainer}>
        <input type="file" onChange={uploadLogo} id="upload-image" />
        <Typography variant="body2" className={classes.attachmentInputText}>
          Drop a picture to upload, or click to select it.
        </Typography>

        {logo ? (
          <Box width="250px" height="300px">
            <img
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
              src={preview ?? logo.src}
              alt={logo.path}
            />
          </Box>
        ) : null}
      </Box>
    </CustomCard>
  );
};

export default ProfileLogo;
